import flex from './flexAuth.component';
import stFlexButton from './flexButton.component';

export default angular
  .module('st.Integrations.Flex', ['st.Core', 'angular-cache'])
  .component('flex', flex)
  .component('stFlexButton', stFlexButton)
  .service('flexService', ($http, dataService, FLEX) => ({
    flexConnect: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, FLEX.API.CREATE_OPPORTUNITY, {
        params
      })
  }))
  .constant('FLEX', {
    API: {
      CREATE_OPPORTUNITY: '/api/v1/integration/flex/create-opportunity'
    }
  });
